import { createSlice } from "@reduxjs/toolkit";

export const feeAuditorsSlice = createSlice({
  name: "feeAuditors",
  initialState: {
    fee_auditors_cases: [],
  },
  reducers: {
    setFeeAuditors: (state, action) => {
      state.fee_auditors_cases = action.payload;
    },
  },
});
export const { setFeeAuditors } = feeAuditorsSlice.actions;
export default feeAuditorsSlice.reducer;
